export const DEPENDENT_RELATIONSHIPS = {
  SPOUSE: "15",
  CHILD: "16",
  OTHER: "-16"
};

export const VALIDATION_CONSTRAINTS = {
  MIN_DEPENDENT_AGE_DAYS: 30,
  MAX_CHILD_AGE: 23,
  COVERAGE_DATE_RANGE: {
    MIN_DAYS_BEFORE: -15,
    MAX_DAYS_AFTER: 45
  }
};

export const MAIN_APPLICANT_FIELDS = [
  "name",
  "surname", 
  "email",
  "gender",
  "country",
  "coverage",
  "birthday"
];

export const DEPENDENT_FIELDS = [
  "name",
  "surname",
  "gender", 
  "country",
  "birthday",
  "componentId"
];

export const ERROR_TYPES = {
  EMPTY: 'empty',
  INVALID: 'invalid',
  BLANK: 'blank',
  INVALID_INPUT_SON: 'invalidInputSon',
  INVALID_INPUT_OTHER: 'invalidInputOther', 
  INVALID_INPUT_SPOUSE: 'invalidInputSpouse',
  BAD_ENTRY: 'badEntry'
};

export const AGE_LIMITS = {
  MIN_AGE: 18,
  MAX_AGE: 75
};

export const VALIDATION_STEPS = {
  STEP_2: 2,
  STEP_4: 4,
  STEP_5: 5,
  STEP_6: 6,
  STEP_8: 8,
  STEP_9: 9
};

export const BENEFIT_VALIDATION_KEYS = {
  MATERNITY_AND_CESAREAN: 'Maternity and cesarean',
  MATERNITY: 'matrnity',
  MATERNITY_NO_VALUE: 'matrnity_no',
  MATERNITY_ID_182: '182'
};

export const GEO_VALIDATION = {
    WORLDWIDE: 'wwide',
    PROVIDER_GLOBAL_OPEN: 'glopen'
};

export const COUNTRY_ISO_NUM = {
    USA: "840",
    COLOMBIA: "170",
};

export const USA_CHILD_LABELS = {
  es: "Temporalmente Expatriado 1",
  en: "Temporally Expat 1",
  pt: "Temporariamente Expat 1"
};

export const COLOMBIA_DEPENDENT_DISCLAIMER = {
  en: "Dependents residing outside of Colombia cannot be added to the policyholder’s policy. Eligible dependents living outside of Colombia must obtain their own individual policy. For assistance with enrolling dependents under a separate policy, please contact our Customer Service Team at +1 (214) 276-6376 or email agentrelations@vumigroup.com.",
  es: "Los dependientes que residan fuera de Colombia no podrán ser añadidos a la póliza del titular. Los dependientes elegibles que vivan fuera de Colombia deberán adquirir una póliza individual propia. Para obtener asistencia con la inscripción de dependientes bajo una póliza por separado, comuníquese con nuestro Equipo de Servicio al Cliente al +1 (214) 276-6376 o envíe un correo electrónico a agentrelations@vumigroup.com.",
  pt: "Dependentes residentes fora da Colômbia não podem ser incluídos na apólice do titular. Os dependentes elegíveis que residam fora da Colômbia deverão contratar sua própria apólice individual. Para obter assistência na inclusão de dependentes em uma apólice separada, entre em contato com nossa Equipe de Atendimento ao Cliente pelo telefone +1 (214) 276-6376 ou pelo e-mail agentrelations@vumigroup.com.",
};

export const COLOMBIA_DEPENDENT_AUTOCHANGE = {
  en: "If your country of residence is Colombia, your dependents must also reside in Colombia. If you continue, the country of residence of all your dependents will be changed to Colombia. Do you want to apply this change?",
  es: "Si tu país de residencia es Colombia, tus dependientes también deben residir en Colombia. Si continúas, el país de residencia de todos tus dependientes se cambiará a Colombia. ¿Deseas aplicar el cambio?",
  pt: "Se o seu país de residência for a Colômbia, seus dependentes também deverão residir na Colômbia. Se você continuar, o país de residência de todos os seus dependentes será alterado para a Colômbia. Deseja aplicar a alteração?",
};
